<ng-template #delete>
    <div id = "pad">
     <div class="modal-header header-style">
        <h3 class="modal-title pull-left">Are you sure?</h3>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">  
        <span class="modal-x" aria-hidden="true"><img class="resize" src="assets/img/icons/icn-remove-dark.svg" alt="close"></span>  
        </button>  
     </div>
     <div class="modal-body bod-text">
        <div class="container-fluid ">
           <div class="row mb-4 info-text ">
            Deleting will remove all information from this request.
           </div>
           <div class="border-line">
              <button type="button" (click)="deletes();" class="btn btn-primary btn-sm">Delete Request</button>
              <button type="button" (click)="modalRef.hide();" class="btn btn-light btn-sm blue-cir">Cancel</button>
           </div>
        </div>
     </div>
    </div>
  </ng-template>
  <app-ind-prov-modal></app-ind-prov-modal>
  <app-confirm-modal></app-confirm-modal>
